import { render, staticRenderFns } from "./formViewer.vue?vue&type=template&id=37f2922a&"
import script from "./formViewer.vue?vue&type=script&lang=js&"
export * from "./formViewer.vue?vue&type=script&lang=js&"
import style0 from "./formViewer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports